import { useRef } from "react";
import { useTransform, useScroll, useSpring } from "framer-motion";
import { MotionBox as Box } from "utils/motion";
import Text from "components/base/Text";
import Container from "components/base/Container";

export default function QuoteSection({ title, author, quote, animationId: _animationId, ...props }) {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["-100vh", "end end"],
  });
  const springScroll = useSpring(scrollYProgress, {
    stiffness: 176,
    damping: 26,
  });
  const opacity = useTransform(springScroll, [0.25, 0.75], [0, 1]);
  const scale = useTransform(springScroll, [0.25, 1], [0.8, 1]);

  return (
    <Box ref={ref} bg="black.900" width="100%" h="100%" position="relative">
      <Container
        minHeight="650px"
        as="section"
        centerContent
        justifyContent="center"
        {...props}
      >
        <Box maxW="lg" px={["0px", null, "xxl"]} style={{ opacity, scale }}>
          {quote && (
            <Text type="p_xxl" color="white" textAlign="center">
              &ldquo;{quote}&rdquo;
            </Text>
          )}
          {author && (
            <Text type="title_md" color="white" textAlign="center" mt="xl">
              {author}
            </Text>
          )}
          {title && (
            <Text type="title_sm" mt="xxs" color="primary" textAlign="center">
              {title}
            </Text>
          )}
        </Box>
      </Container>
    </Box>
  );
}
